// extracted by mini-css-extract-plugin
module.exports = {"events":"events__FVqia"};